import GroupedTextFilterGrid from "./GroupedTextFilterGrid.tsx";
import TextFilterServerGrid from "./TextFilterServerGrid.tsx";
import type { TextFilterGridGrouping, TextFilterGridProps } from "./textFilterGridTypes.ts";

interface Props extends TextFilterGridProps {
  grouping?: TextFilterGridGrouping;
}

const TextFilterGrid = (props: Props) => {
  const { grouping, ...gridProps } = props;
  // MUI does not reset its lazy-loading cursor when the data source changes, so each flat query needs a fresh grid.
  return grouping === undefined ? (
    <TextFilterServerGrid key={gridProps.queryKey} {...gridProps} />
  ) : (
    <GroupedTextFilterGrid key={gridProps.queryKey} {...gridProps} grouping={grouping} />
  );
};

export default TextFilterGrid;
